import { MIDDLE_BUTTON_ID } from '../constants.js';
import {
  DragEnd,
  DragMove,
  DragStart,
  MiddleButtonDragEnd,
  MiddleButtonDragMove,
  MiddleButtonDragStart,
  PointerEventActions,
  RelativeAbsolutePosition,
} from '../types/pointer-events.js';

const getEndActionByPreviousAction = (
  prevGesture: MiddleButtonDragMove | DragMove,
) =>
  prevGesture.action === PointerEventActions.MiddleButtonDragMove
    ? PointerEventActions.MiddleButtonDragEnd
    : PointerEventActions.DragEnd;

export const buildDragEndEvent = (
  prevGesture: MiddleButtonDragMove | DragMove,
  startHoldingAt: RelativeAbsolutePosition,
  releasedAt: RelativeAbsolutePosition,
): DragEnd | MiddleButtonDragEnd => ({
  action: getEndActionByPreviousAction(prevGesture),
  startHoldingAt,
  releasedAt,
});

const getMoveActionByButton = (button: number) =>
  button === MIDDLE_BUTTON_ID
    ? PointerEventActions.MiddleButtonDragMove
    : PointerEventActions.DragMove;

export const buildDragMoveEvent = (
  button: number,
  startHoldingAt: RelativeAbsolutePosition,
  prevPosition: RelativeAbsolutePosition,
  currentPosition: RelativeAbsolutePosition,
): DragMove | MiddleButtonDragMove => {
  const delta = currentPosition.relative.x - prevPosition.relative.x;
  return {
    action: getMoveActionByButton(button),
    startHoldingAt,
    currentPosition,
    delta,
  };
};

const getStartActionByButton = (button: number) =>
  button === MIDDLE_BUTTON_ID
    ? PointerEventActions.MiddleButtonDragStart
    : PointerEventActions.DragStart;

export const buildDragStartEvent = (
  button: number,
  startHoldingAt: RelativeAbsolutePosition,
): DragStart | MiddleButtonDragStart => ({
  action: getStartActionByButton(button),
  startHoldingAt,
});
